import { render, staticRenderFns } from "./ais.vue?vue&type=template&id=6d02dce8&scoped=true&"
import script from "./ais.vue?vue&type=script&lang=js&"
export * from "./ais.vue?vue&type=script&lang=js&"
import style0 from "./ais.vue?vue&type=style&index=0&id=6d02dce8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d02dce8",
  null
  
)

export default component.exports